import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { TopHeaderRightSectionComponent } from './top-header-right-section/top-header-right-section.component';
import { TopHeaderTabsComponent } from './top-header-tabs/top-header-tabs.component';
import { tap } from 'rxjs';
import { ViewDetectionService } from '../../services/view-detection.service';
import { PageContainerService } from '../../services/page-container.service';

@Component({
  selector: 'st-top-header',
  standalone: true,
  imports: [
    CommonModule,
    TopHeaderTabsComponent,
    TopHeaderRightSectionComponent,
  ],
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss'],
})
export class TopHeaderComponent {
  logoUrl = input.required<string>();
  isExpand = signal<boolean>(false);
  gridView$ = this.viewDetection.gridView;

  expandMenuDrawer$ = this.pageContainerService.expandMenuDrawer$.pipe(
    tap(x => {
      if (x) this.pageContainerService.expandFilterDrawer$.next(!x);
      if (x !== this.isExpand()) {
        this.isExpand.set(x);
      }
    }),
  );

  constructor(
    readonly viewDetection: ViewDetectionService,
    readonly pageContainerService: PageContainerService,
  ) {}

  expandDrawer() {
    this.isExpand.update(x => !x);
    this.pageContainerService.expandMenuDrawer$.next(this.isExpand());
  }
}
